<template>
  <div>
    <input
      class="px-6 py-2 focus:outline-none border  w-full rounded-lg"
      ref="inputRef"
      type="text"
      v-bind="$attrs"
    />
  </div>
</template>

<script>
import { useCurrencyInput } from 'vue-currency-input'

export default {
  name: 'CurrencyInput',
  props: {
    modelValue: Number,
    options: Object
  },
  setup(props) {
    const { inputRef } = useCurrencyInput(props.options)

    return { inputRef }
  }
}
</script>